module.exports = __webpack_public_path__ + "assets/quqi.7f035156.svg";